import React from "react";
import "./Team.css";

const teamMembers = [
  { id: 1, name: "Emily Robinson", role: "Creative Director", image: "/image/team-1.jpg" },
  { id: 2, name: "James Mitchell", role: "Digital Strategy Specialist", image: "/image/team-2.jpg" },
  { id: 3, name: "Sophia Bennett", role: "Social Media Manager", image: "/image/team-3.jpg" },
  { id: 4, name: "Emily Robinson", role: "Creative Director", image: "/image/team-1.jpg" },
  { id: 5, name: "James Mitchell", role: "Digital Strategy Specialist", image: "/image/team-2.jpg" },
  { id: 6, name: "Sophia Bennett", role: "Social Media Manager", image: "/image/team-3.jpg" },  
  
];

const Team = () => {
  return (
    <div className="teamSection">
      <h3 className="subHeading">OUR TEAM</h3>
      <h2 className="heading">
        Discover the team driving our <br /> creative and strategic success
      </h2>
      <div className="teamMembers">
        {teamMembers.map((member) => (
          <div className="cardM" key={member.id}>
            <div className="member">
              <img src={member.image} alt={member.name} className="image" />
              <h3 className="name">{member.name}</h3>
              <p className="role">{member.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
